/* eslint-disable complexity */
import { Separator } from '@e2n/ui';
import { BerechnetesMonatssoll } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/BerechnetesMonatssoll';
import { BerechnungsartMonatToggle } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/BerechnungsartMonatToggle';
import { SollstundenToggle } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/SollstundenToggle';
import { StundenMonat } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/StundenMonat';
import { StundenpensumToggle } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/StundenpensumToggle';
import { StundenWoche } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/StundenWoche';
import { TageSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/TageSelect';
import { Tagessoll } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/Tagessoll';
import { UnbezahlteUeberstunden } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/UnbezahlteUeberstunden';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';

export function Sollstunden() {
  const { ctx } = useAnlageassistentContext();

  const form = useAnlageassistentFormContext();

  return (
    <form.Subscribe
      selector={(state) => ({
        gehaltsempfaenger:
          state.values.bezahlung.arbeitszeitkonto.gehaltsempfaenger,
      })}>
      {({ gehaltsempfaenger }) => (
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-4">
            <h2 className="text-neutrals-900 text-xl font-bold leading-7">
              {ctx.getCurrentSubStep()?.title}
            </h2>
            <SollstundenToggle />
          </div>
          {gehaltsempfaenger.sollstunden && <StundenpensumToggle />}

          <div className="flex flex-col gap-6">
            {gehaltsempfaenger.sollstunden &&
              gehaltsempfaenger.stundenpensum === 'monat' && (
                <BerechnungsartMonatToggle />
              )}
            {gehaltsempfaenger.sollstunden &&
              gehaltsempfaenger.stundenpensum === 'monat' &&
              gehaltsempfaenger.berechnungsartMonat === 'durchschnitt' && (
                <StundenMonat />
              )}
            {gehaltsempfaenger.sollstunden &&
              gehaltsempfaenger.stundenpensum === 'woche' && <StundenWoche />}
            {gehaltsempfaenger.sollstunden &&
              gehaltsempfaenger.stundenpensum === 'monat' &&
              gehaltsempfaenger.berechnungsartMonat === 'exakt' && (
                <div className="flex flex-col gap-6 pb-10">
                  <TageSelect />
                  <Tagessoll />
                  <Separator className="my-2" />
                  <BerechnetesMonatssoll />
                  <UnbezahlteUeberstunden className="max-w-96" />
                </div>
              )}
          </div>
        </div>
      )}
    </form.Subscribe>
  );
}
